'use es6';

import PropTypes from 'prop-types';
import { useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { PopoverBodyLiteIcons } from '../../constants/popover';
import PopoverBodyLiteBase from '../PopoverBodyLiteBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.anchor.lite.${suffix}`;
const StyledTruncatedString = styled(UITruncateString).withConfig({
  displayName: "AnchorPopoverBodyLite__StyledTruncatedString",
  componentId: "sc-1vofxw3-0"
})(["display:inline-flex !important;"]);
const propTypes = {
  anchorId: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
  onAnchorRemove: PropTypes.func.isRequired
};
function AnchorPopoverBodyLite(props) {
  const {
    anchorId,
    onEdit,
    onAnchorRemove
  } = props;
  const [iconButtons] = useState([{
    iconName: PopoverBodyLiteIcons.EDIT,
    onClick: onEdit
  }, {
    iconName: PopoverBodyLiteIcons.REMOVE,
    onClick: onAnchorRemove
  }]);
  return /*#__PURE__*/_jsx("div", {
    className: "animated-popover-preview",
    children: /*#__PURE__*/_jsx(PopoverBodyLiteBase, {
      "data-test-id": "anchor-popover-body-lite",
      iconButtons: iconButtons,
      i18nKey: i18nKey,
      children: /*#__PURE__*/_jsx(UIBox, {
        className: "p-left-3 p-right-2",
        alignSelf: "center",
        children: /*#__PURE__*/_jsxs(UIFormLabel, {
          className: "p-y-0 p-x-0 link-preview-form-label",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('label')
          }), /*#__PURE__*/_jsx(StyledTruncatedString, {
            maxWidth: 100,
            children: anchorId
          })]
        })
      })
    })
  });
}
AnchorPopoverBodyLite.propTypes = propTypes;
AnchorPopoverBodyLite.displayName = 'AnchorPopoverBodyLite';
export default AnchorPopoverBodyLite;